module.exports = __webpack_public_path__ + "img/add-user.3f09b663.svg";